
import React from 'react';
import { Activity } from 'lucide-react';
import { ExchangeBadges } from './ExchangeBadges';
import { ExchangePlatform } from '@/types/trader';
import { useTranslation } from 'react-i18next';

interface BotInfoProps {
  description: string;
  connectedAccounts: number;
  exchanges: ExchangePlatform[];
}

export const BotInfo: React.FC<BotInfoProps> = ({
  description,
  connectedAccounts,
  exchanges
}) => {
  const { t } = useTranslation();

  // Truncate description to 2 lines (approximately 100 characters)
  const truncateDescription = (text: string) => {
    if (text.length <= 100) return text;
    return text.substring(0, 97) + '...';
  };

  return (
    <>
      <p className="text-sm text-muted-foreground mb-4 line-clamp-2 h-10">
        {truncateDescription(description)}
      </p>
      
      <div className="flex flex-col space-y-2 mb-4">
        <div className="flex items-center space-x-2">
          <Activity size={16} className="text-muted-foreground" />
          <span className="text-sm text-muted-foreground">
            {connectedAccounts} {connectedAccounts === 1 ? t('account') : t('accounts_label')} {t('connected_accounts')}
          </span>
        </div>
        
        <ExchangeBadges exchanges={exchanges} />
      </div>
    </>
  );
};
